import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { OccupancyModel } from '@/features/occupancyDashboard/types';

async function getDetailOccupancy(serieId: number): Promise<OccupancyModel> {
  const api = await getApi();
  const { data } = await api.get('/painel-ocupacao/', {
    params: {
      serie_id: serieId
    }
  });

  return data[0];
}

type QueryFnType = typeof getDetailOccupancy;

function useDetailOccupancy(serieId: number | null) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-detail-occupancy'],
    queryFn: () => getDetailOccupancy(serieId),
    enabled: !!serieId,
  });
}

export { getDetailOccupancy, useDetailOccupancy };
